import { render } from "./TeachingPlanPhraseTab.vue?vue&type=template&id=4fd52c97&scoped=true&ts=true"
import script from "./TeachingPlanPhraseTab.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanPhraseTab.vue?vue&type=script&lang=ts"

import "./TeachingPlanPhraseTab.vue?vue&type=style&index=0&id=4fd52c97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd52c97"]])

export default __exports__